/* Functions for the top-info-bar */

jQuery( function( $ ) {
	const topbar = window.localStorage.getItem( 'topbar' );
	const $infoBar = $( '.info-bar' );

	$( '.info-bar__close' ).on( 'click', function() {
		$infoBar.css( 'display', 'none' );
		window.localStorage.setItem( 'topbar', 'true' );
		$( 'body' ).removeClass( 'info-bar-toggled' );
	} );

	if ( 'true' !== topbar && $infoBar.length ) {
		$infoBar.css( 'display', 'block' );
	}

	/**
	 * Adjusts the page-margin if cookie bar is visible
	 */
	function positionPage() {
		const $cookie = $( '.custom-cookie-message-banner--top-fixed' );

		if ( $cookie.length ) {
			$( '#page' ).css( 'margin-top', $cookie.outerHeight() );
		}
	}

	$( document ).ready( function() {
		setTimeout( positionPage, 700 );
	} );

	/**
	 * Reset the page-margin if cookie bar is closed
	 */
	$( 'body' ).on( 'click', '.custom-cookie-message-banner__close', function() {
		$( '#page' ).css( 'margin-top', '0' );
	} );
} );
